// Entry point simply exporting the required import.
// This is needed as babel does not support mixing of "import ..." and "modules.exports = {...}"
// So we "hack" it here.
/* global module */
module.exports = {
  ...require('./boot.js')
}
